export default __webpack_public_path__ + "static/media/logo-app2.84737903.svg";